import { defineMessages } from 'react-intl';

export default defineMessages({
    requiringPostIssueReview: {
        id: 'custom.quoteandbind.pa.views.pa-policy-info.for Underwriting Post-Issue Review',
        defaultMessage: 'for Underwriting Post-Issue Review',
    },
});
